import { render } from "./DataSearch.vue?vue&type=template&id=68ddd544"
import script from "./DataSearch.vue?vue&type=script&lang=js"
export * from "./DataSearch.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataTable/DataSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68ddd544"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68ddd544', __exports__)) {
    console.log('reload')
    api.reload('68ddd544', __exports__)
  }
  
  module.hot.accept("./DataSearch.vue?vue&type=template&id=68ddd544", () => {
    console.log('re-render')
    api.rerender('68ddd544', render)
  })

}


export default __exports__